import { render, staticRenderFns } from "./distribution.vue?vue&type=template&id=b944a7ca&scoped=true&"
import script from "./distribution.vue?vue&type=script&lang=js&"
export * from "./distribution.vue?vue&type=script&lang=js&"
import style0 from "./distribution.vue?vue&type=style&index=0&id=b944a7ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b944a7ca",
  null
  
)

export default component.exports